import { apiClient } from './axiosSettings';

export async function fetchSummary(conversationId: string, endpoint: string, source: any, headers: any) {
  return apiClient.get(`${endpoint}/feedback/finalsummary?ContentId=${conversationId}`, { cancelToken: source.token, headers: headers })
}